export const getToastNotificationId = (page: string, id: string): string => {
  return `${page}-${id}`;
};
